document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cmc]').forEach(initCmc);
});

function initCmc(root) {

// Disabilita il carousel nei Prodotti correlati
if (root.closest('.related-products-section')) return;


  const track = root.querySelector('.cmc-track');
  if (!track) return;

  const slides = Array.from(root.querySelectorAll('.cmc-slide'));
  const dots   = Array.from(root.querySelectorAll('.cmc-dot'));

  let index = 0;
  const goTo = (i) => {
    index = Math.max(0, Math.min(i, slides.length - 1));
    track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
    dots.forEach((d, k) => d.classList.toggle('is-active', k === index));
  };

  // Dots click
  dots.forEach((d, i) => d.addEventListener('click', (e) => {
    e.preventDefault();
    goTo(i);
  }));

  // Sync dots su swipe manuale
  let ticking = false;
  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index) {
        index = i;
        dots.forEach((d, k) => d.classList.toggle('is-active', k === index));
      }
      ticking = false;
    });
  });

  // Riallinea sul resize
  window.addEventListener('resize', () => goTo(index), { passive: true });

  // Tap-to-open al centro (niente frecce da escludere)
  const openUrl = root.dataset.url;
  let startX = 0, startY = 0, startTime = 0, moved = false;

  const TAP_MAX_DIST = 10;   // px
  const TAP_MAX_TIME = 300;  // ms
  const CENTER_MIN = 0.25;   // 25% - 75%
  const CENTER_MAX = 0.75;

  track.addEventListener('pointerdown', (e) => {
    // ignora tap sui dots
    if (e.target.closest('.cmc-dot')) return;
    startX = e.clientX;
    startY = e.clientY;
    startTime = performance.now();
    moved = false;
  });

  track.addEventListener('pointermove', (e) => {
    if (startTime === 0) return;
    const dx = Math.abs(e.clientX - startX);
    const dy = Math.abs(e.clientY - startY);
    if (dx > TAP_MAX_DIST || dy > TAP_MAX_DIST) moved = true;
  });

  track.addEventListener('pointerup', (e) => {
    if (startTime === 0) return;
    const dt = performance.now() - startTime;
    const wasTap = !moved && dt <= TAP_MAX_TIME;
    startTime = 0;

    if (!wasTap) return;
    if (e.target.closest('.cmc-dot')) return;

    const rect = track.getBoundingClientRect();
    const relX = (e.clientX - rect.left) / rect.width; // 0..1
    if (relX >= CENTER_MIN && relX <= CENTER_MAX) {
      if (openUrl) window.location.href = openUrl;
    }
  });

  track.addEventListener('pointercancel', () => { startTime = 0; moved = false; });
}
